import React, { Component } from 'react';
import SuccessFooter from '../footer/successfullFooter';
import {Helmet} from "react-helmet";
import metatags from '../static/metatags';
class Failed extends React.Component {
  constructor(props){
    super(props);
    this.state = {

    }
  }
  componentDidMount = () => {
    window.scrollTo(0, 0);
    // this.props.headerHideFun();
  };

  render() {
    return (
      <>
        <section className="cmx-failed-page">
          <Helmet>
            <title>{metatags.commonMetatag.title}</title>
            <meta name="description" content={metatags.commonMetatag.description} />
          </Helmet>
          <aside className='head-blk text-center'>
            <h1>Purchase Failed for your <span>CMX Passport Subscription</span></h1>
          </aside>
          <section className='change-sec'>
            <p>Any charges to your account will be reversed automatically.</p>
            <p>Please <a href="https://www.cmxcinemas.com/contact" title='Contact Us' target="_blank">Contact Us</a> if you have any questions</p>
          </section>
        </section>
        {/* <SuccessFooter /> */}
      </>
    )
  }
}

export default Failed;
